export interface SupportCenterParameter {
  id: string
  key: string
  value: string
  description?: string | null
  created_at: string
  updated_at: string
}

export const SUPPORT_CENTER_PARAM_DIAS_MAX = 'agendamento_dias_max'
export const SUPPORT_CENTER_PARAM_HORAS_ANTECEDENCIA = 'agendamento_horas_antecedencia'
export const SUPPORT_CENTER_PARAM_TOLERANCIA_MINUTOS = 'agendamento_tolerancia_minutos'

export type SupportCenterSchedulingLimits = {
  maxDaysAhead: number
  minHoursAhead: number
  /** Minutos após o scheduled_at em que ainda se pode realizar triagem/atendimento. */
  pastToleranceMinutes: number
}

export const DEFAULT_SCHEDULING_LIMITS: SupportCenterSchedulingLimits = {
  maxDaysAhead: 30,
  minHoursAhead: 1,
  pastToleranceMinutes: 10,
}
